/* eslint max-params: off */
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FocusSDK, isBjme, isFocusEnv } from "@/utils";
import {
  UserSelectionOptions,
  UserSelectionResult
} from "@jd/focus-desktop-comps/lib/es/UserSelectionModal";
import i18next from "i18next";
import { Modals } from "@jd/focus-desktop-comps";
import logger from "@/utils/logger";
import {
  getAllRelationShip,
  getEbookDeptInfo,
  getEbookOrgInfo,
  getPersonalDetail,
  getUserEbookDetail,
  getVirtualUserDetail,
  getTagList,
  getTagEmpls
} from "@/api/ebook";
import {
  getSearchGlobal,
  getSearchStranger,
  searchExternalContacts,
  searchGlobal
} from "@/api/search";
import {
  getBusinessData,
  getExternalContacts,
  getGroupData,
  getRecentChatSession,
  getRecentIncludeGroup,
  getTopChatSession,
  onGetRecommendInfo,
  searchSessions,
  getGroupMembersData,
  onSearchGroupMember,
  setModifyFriend
} from "@/api/chat";
import { UserModel } from "@/models/user";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { JoinMeetingModalProps } from "@jd/focus-desktop-comps/lib/es/JoinMeetingModal";
import {
  BusinessTabParam,
  RecommendParam,
  SearchGlobalParams,
  UserSelTab
} from "@jd/focus-desktop-comps/lib/es/UserSelection";
import {
  UserCardType,
  UserCardAction,
  UserCardData,
  UserCardActionClickInfo
} from "@jd/focus-desktop-comps/lib/es/UserCard/UserCardType";
import pick from "lodash/pick";
import { uniq } from "lodash";
import ImService from "@/server/ImService";
import {
  appliesNewContacts,
  getWorkLineInfoList,
  openUserCardModal
} from "@/components/AddressBook/common";
import { analysisComponetUvLog, analysisLog } from "./logAnalytics";
import { examineMobileRecord, remarkSet } from "@/api/addressBook";
import { UserCardOnFns, UserCardOptions } from "@jd/focus-desktop-comps/lib/es/WebUserCardModal";
import { Employee } from "@/types/chat";
import useShareUserCard from "@/components/Modals/useShareUserCard";
import Bus from "@/utils/bus";
import styles from "@/components/styles";
// import { openUserCardModal } from '@/components/AddressBook/common';
import { changeEgovUrl } from "@/utils/tools";
import userCardIcon from "@/assets/img/user-card-icon.png";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { GetEbookWorkLineReq } from "@jd/jdee.im.sdk/lib/es/service/WorkLine";
import config, { ConfigEnum } from "@/config/config";

const log = logger.getLogger("utils/modals");
let closeUserSelectionModalFunc: any = null;

export function openJoinMeetingModal(options: Partial<JoinMeetingModalProps>) {
  if (isFocusEnv()) {
    //
  } else {
    const { destroy } = Modals.JoinMeeting({
      ...options,
      onCancel: () => {
        destroy();
      }
    });
  }
}

/**
 * 获取默认的联系人选择器tabs,默认项：组织架构，工作条线，我的联系人
 * @param disableTabs 需要禁用的默认tab，非必填
 */
export function getUserSelectionDefaultTabs(
  disableTabs: UserSelTab[] = []
): (keyof typeof UserSelTab)[] {
  const tabs: any = !config[ConfigEnum.EXTERNAL_CONTACTS_ORG]
    ? ["externalContacts", "workLine", "tag"]
    : ["org", "workLine", "externalContacts", "tag"];
  return tabs.filter((i: any) => !disableTabs.includes(i));
}

/**
 * 打开默认的联系人选择器，会拼接默认的tab，只需传入默认之外的tabs，
 * 排序的tab+默认tab+剩余非默认tab，排序优先级最高
 * tabSort按数值大小，正序排序，即1在最前面
 */
export function openUserSelectionDefaultModal(
  options: UserSelectionOptions & {
    propAgentForData?: any[];
    disableDefaultTabs?: UserSelTab[];
    tabSort?: {
      tab: keyof typeof UserSelTab;
      sort: number;
    }[];
  },
  cb: (
    data: UserSelectionResult,
    close: () => void,
    update: (newConfig: any) => void,
    cancelLoadingFn: () => void
  ) => void,
  user: UserModel | { teamUserInfo: { teamId: any }; ddAppId: string; userId: string },
  onCancel?: () => any
) {
  let tabs = uniq(
    getUserSelectionDefaultTabs(options.disableDefaultTabs).concat(options.tabs || [])
  );
  if (options.tabSort) {
    const needSortTabs = tabs.filter((i) => !!options.tabSort?.find((t) => t.tab === i));
    needSortTabs.sort((a, b) => {
      return (
        (options.tabSort?.find((i) => i.tab === a)?.sort || 0) -
        (options.tabSort?.find((i) => i.tab === b)?.sort || 0)
      );
    });
    tabs = uniq(needSortTabs.concat(tabs));
  }
  openUserSelectionModal(
    {
      ...options,
      currentUser: {
        app: user.ddAppId,
        pin: user.userId,
        teamId: user.teamUserInfo?.teamId
      },
      tabs
    },
    cb,
    user,
    onCancel
  );
}
export function openUserSelectionModal(
  options: UserSelectionOptions & { propAgentForData?: any[] },
  cb: (
    data: UserSelectionResult,
    close: () => void,
    update: (newConfig: any) => void,
    cancelLoadingFn: () => void
  ) => void,
  user: UserModel | { teamUserInfo: { teamId: any }; ddAppId: string; userId: string },
  onCancel?: () => any
) {
  const { propAgentForData } = options;
  analysisComponetUvLog({
    cn: "userSelect",
    at: "enter"
  });
  const tabs = options.tabs || [];
  if (user.teamUserInfo?.teamId === FocusSDK.getBjwpConfig()?.teamId) {
    // 网评员去掉常用联系人；
    const recentIdx = tabs.indexOf("recent");
    if (recentIdx >= 0) {
      tabs.splice(recentIdx, 1);
    }
  }
  const { destroy, update } = Modals.UserSelecton(
    {
      ...options,
      tabs,
      getSearchExtraPart: (item: ListItemData) => {
        return (
          <div
            style={{
              color: styles.color.primary2,
              marginLeft: 5,
              width: 34,
              height: 30,
              textAlign: "center",
              cursor: "pointer"
            }}
            onClick={(event: any) => {
              event.stopPropagation();
              analysisLog("xtbg_add_home_1637657110163", "79");
              const option = {
                ...item,
                app: item?.origin?.uid?.app || item.app,
                userId: item?.origin?.uid?.userId || item.userId,
                teamId: item?.origin?.uid?.teamId || item.teamId,
                type: UserCardType.CustomUser
              };
              openUserCardModal(option as ListItemData);
            }}
          >
            <img src={changeEgovUrl(userCardIcon)} alt="" style={{ width: 20 }} />
          </div>
        );
      }
    },
    (result: any) => {
      return new Promise((resolve) => {
        cb(
          result,
          () => {
            console.log("result=======>", result);
            resolve();
            destroy();
            closeUserSelectionModalFunc = null;
          },
          update,
          () => {
            resolve();
          }
        );
      });
    },
    {
      t: (...args: any[]) => {
        // @ts-ignore
        // 暂时区分一下专班 项目
        const param = args;
        if (!isBjme() && param[0].indexOf("specialProject") > -1) {
          param[0] = param[0].replace("specialProject", "project");
        }
        return i18next.t(param);
      },
      onGetAvatarURL: (url: string) => {
        return getHeadImgThumbUrl(url, 150, 150);
      },
      onGetEBookDeptInfo: async (params: {
        deptId?: string | undefined;
        displaySubDept?: boolean | undefined;
      }) => {
        let result = null;
        try {
          result = await getEbookDeptInfo(params);
        } catch (e) {
          // if (e.message.indexOf('10230004')) {}
          result = {};
        }
        return result as any;
      },
      onGetTagData: async () => {
        const [res, err] = await getTagList();
        if (err) {
          return [];
        }
        return res.tagList;
      },
      onGetTagMembersData: async (tagId: string) => {
        const [res, err] = await getTagEmpls(tagId);
        if (err) {
          return [];
        }
        return res.list;
      },
      onGetEBookWorkLineInfo: async (params: GetEbookWorkLineReq) => {
        let result = null;
        try {
          result = await getWorkLineInfoList(params);
        } catch (e) {
          // if (e.message.indexOf('10230004')) {}
          result = {};
        }
        return result as any;
      },
      onGetEBookOrgInfo: async (params: {
        appId?: string;
        deptId?: string;
        displaySubDept?: boolean;
      }) => {
        let result = null;
        try {
          result = await getEbookOrgInfo(params);
        } catch (e) {
          // if (e.message.indexOf('10230004')) {}
          result = {};
        }
        return result as any;
      },
      onSearchStranger: async (params: { keyword: string }) => {
        try {
          const result = await getSearchStranger(params);
          log.debug("onSearchStranger", result);
          return result as any;
        } catch (e) {
          return {};
        }
      },
      onSearchGlobal: async (params: SearchGlobalParams) => {
        try {
          const result = await getSearchGlobal(params);
          // if (params.searchType === SearchType.Contacts) {
          //     const externalContacts = await searchExternalContacts(params);
          //     let contactsList = externalContacts.filter(
          //         (item: any) =>
          //             !result.contacts.some(
          //                 (ele: any) =>
          //                     ele.userId === item.userId &&
          //                     ele.app === item.app &&
          //                     ele.teamId === item.teamId
          //             )
          //     );
          //     result.contacts.unshift(...contactsList);
          // }
          // if (params.needSession) {
          //     result.sessions = await searchSessions(params);
          // }
          log.debug("onSearchGlobal", result);
          return result as any;
        } catch (e) {
          return {};
        }
      },
      onGetRecentData: () => getRecentChatSession(),
      onGetRecentIncludeGroup: async () => await getRecentIncludeGroup(),
      onGetAgentForData: propAgentForData
        ? () => Promise.resolve(propAgentForData)
        : () => getRecentChatSession(),
      onGetTopData: () => getTopChatSession(user.teamUserInfo.teamId),
      onGetExternalContacts: () => getExternalContacts(),
      onGetGroupData: () => getGroupData(),
      onGetGroupMembersData: (groupId: string) => getGroupMembersData(groupId),
      onGetBusinessData: (param: BusinessTabParam) => getBusinessData(param, user),
      onGetRecommendInfo: (param: RecommendParam) => onGetRecommendInfo(param, user),
      onSearchGroupMember: (keyword: string, searchData?: ListItemData[]) =>
        onSearchGroupMember(keyword, searchData), // 模糊搜索群成员
      onAnalysisLog: (log_type1: string, log_type2: string, ...ret: Array<string>) =>
        analysisLog(log_type1, log_type2, ...ret)
    }
  );
  closeUserSelectionModalFunc = destroy;
}

export function closeUserSelectionModal() {
  if (closeUserSelectionModalFunc) {
    closeUserSelectionModalFunc();
  }
}
export async function handleRemarkSet(user: any, value: string) {
  const [_, err] = await remarkSet({
    appId: user.appId,
    teamId: user.teamId,
    userId: user.userId,
    remark: value
  });
  if (err) {
    console.error(err);
    return false;
  }
  try {
    // 同步到本地数据库
    const imService = ImService.getInstance();
    imService.setClientUser(
      { appId: user.appId, teamId: user.teamId, userId: user.userId },
      { ...user, remark: value }
    );
  } catch (error) {
    console.error("set local error", error);
  }
  Bus.emit("ebook:updateExternalContacts", { ...user, remark: value });

  return true;
}

export function openCustomUserCardModal(
  options: UserCardOptions,
  actionClickFn: (props: UserCardActionClickInfo) => void
  // onOk: (data: UserSelectionResult) => Promise<void>,
) {
  const { destroy, update } = Modals.UserCard(options, {
    onActionClick: (props: UserCardActionClickInfo) =>
      actionClickFn({
        ...props,
        data: {
          ...props.data,
          close: () => {
            destroy();
          }
        } as any
      }),
    getAllRelationShip: (params: { oppoUserId: string; oppoTeamId: string; appId: string }) =>
      getAllRelationShip(params),
    onGetUserInfo: async (params: {
      userId: string;
      teamId: string;
      appId: string;
      rootOrgId?: string;
    }) => {
      let result: any;
      if (params.rootOrgId) {
        result = await getVirtualUserDetail(params);
      } else {
        // imService.getEmployeeDetail不调用是因为在三方应用中调起人员选择器独立窗口人员信息会打开个人名片页 不会走getEmployeeDetail方法中imsdk的接口
        result = await getUserEbookDetail({
          ...pick(params, ["appId", "userId", "teamId"]),
          isMulti: true
        });
      }
      return result || null;
    },
    appliesNewContacts: () => appliesNewContacts(),
    setModifyFriend: (params: any) => setModifyFriend(params),
    analysisLog: (log_type1: string, log_type2: string, ...ret: Array<string>) =>
      analysisLog(log_type1, log_type2, ...ret),
    examineMobileRecord: (params: any) => examineMobileRecord(params),
    remarkSet: (user: any, value: string) => {
      return handleRemarkSet(user, value);
    },
    onClose: () => {
      destroy();
    }
  });
}

// export function openUserSelectionModal(
//     options: UserSelectionOptions,
//     cb: (data: UserSelectionResult, close: () => void) => void,
//     user: UserModel
// ) {
//     if (isFocusEnv() && !isSupportEnv()) {
//         FocusSDK.userSelection(options, (data: UserSelectionResult, close: () => void) => {
//             cb(data, close);
//         });
//     } else {
//         const { destroy } = Modals.UserSelecton(
//             options,
//             (result: any) => {
//                 return new Promise((resolve) => {
//                     cb(result, () => {
//                         resolve();
//                         destroy();
//                     });
//                 });
//             },
//             {
//                 t: (...args: any[]) => {
//                     // @ts-ignore
//                     return i18next.t(...args);
//                 },
//                 onGetAvatarURL: (url: string) => {
//                     return getHeadImgThumbUrl(url, 150, 150);
//                 },
//                 onGetEBookDeptInfo: async (params: {
//                     deptId?: string | undefined;
//                     displaySubDept?: boolean | undefined;
//                 }) => {
//                     let result = null;
//                     try {
//                         result = await getEbookDeptInfo(params);
//                     } catch (e) {
//                         // if (e.message.indexOf('10230004')) {}
//                         result = {};
//                     }
//                     return result as any;
//                 },
//                 onGetEBookOrgInfo: async (params: {
//                     appId?: string;
//                     deptId?: string;
//                     displaySubDept?: boolean;
//                 }) => {
//                     let result = null;
//                     try {
//                         result = await getEbookOrgInfo(params);
//                     } catch (e) {
//                         // if (e.message.indexOf('10230004')) {}
//                         result = {};
//                     }
//                     return result as any;
//                 },
//                 onSearchGlobal: async (params: SearchGlobalParams) => {
//                     const result = await searchGlobal(params);
//                     if (params.searchType === SearchType.Contacts) {
//                         const externalContacts = await searchExternalContacts(params);
//                         result.contacts.unshift(...externalContacts);
//                     }
//                     log.debug('onSearchGlobal', result);
//                     return result as any;
//                 },
//                 onGetRecentData: () => getRecentChatSession(user.selectedTeamId),
//                 onGetTopData: () => getTopChatSession(user.selectedTeamId),
//                 onGetExternalContacts: () => getExternalContacts(),
//                 onGetGroupData: () => getGroupData(),
//             }
//         );
//     }
// }
